export default __webpack_public_path__ + "static/mosaic-cursor-dont-light-ae837c5b16cac49d58b346f69fb44432.png";